export default __webpack_public_path__ + "static/preview-40fe9c69a6966c77839312297f154bb2.jpg";